import {Address} from '#apollo/schema';

import {ShippingAddress} from './FormEditShipping.types';

export const parseShippingAddress = (
  firstName: string,
  lastName: string,
  shippingAddress?: Address,
): ShippingAddress => {
  return {
    firstName: shippingAddress?.firstName ?? firstName ?? undefined,
    lastName: shippingAddress?.lastName ?? lastName ?? undefined,
    address: shippingAddress?.address,
    city: shippingAddress?.city,
    state: shippingAddress?.provinceCode,
    postalCode: shippingAddress?.postalCode,
    addressDetail: shippingAddress?.addressDetail ?? undefined,
    country: shippingAddress?.countryCode ?? undefined,
  };
};
